const shouldAddLog = typeof window !== 'undefined';

export const logger = {
  error: (...args: unknown[]) => {
    if (shouldAddLog) console.error(...args);
  },
  warn: (...args: unknown[]) => {
    if (shouldAddLog) console.warn(...args);
  },
  info: (...args: unknown[]) => {
    if (shouldAddLog) console.info(...args);
  },
  log: (...args: unknown[]) => {
    if (shouldAddLog) console.log(...args);
  },
};
